(function( app, marketinDeepLink, $, undefined ) {
  'use strict';

  var form_elements = {
    'enable_internal_deep_link': '#marketing_deep_link_use_internal_deep_link',
    'external_deep_link': '#marketing_deep_link_external_link_url_input',
    'internal_deep_link': '#marketing_deep_link_deep_link_input'
  }

  // Public Method
  marketinDeepLink.initForm = function() {
    $(form_elements['enable_internal_deep_link']).on('change', function() {
      _setDeepLinkInput()
    });
    _setDeepLinkInput()
  }

  function _setDeepLinkInput() {
    var internalEnabled = $(form_elements['enable_internal_deep_link'])
    
    if(internalEnabled.is(':checked')){
      $(form_elements['internal_deep_link']).removeClass('hidden_input')
      $(form_elements['external_deep_link']).addClass('hidden_input')
    }
    else{
      $(form_elements['internal_deep_link']).addClass('hidden_input')
      $(form_elements['external_deep_link']).removeClass('hidden_input')
    }
  }

}( window.app ||= {}, 
  window.app.marketinDeepLink ||= {}, 
  jQuery 
));

(function ($) {
  $(function() {
    // INIT the Homepage Offer Slot form
    if ($('#edit_marketing_deep_link').length) {
      app.marketinDeepLink.initForm();
    }

    if ($('#new_marketing_deep_link').length) {
      app.marketinDeepLink.initForm();
    }
  })
})(jQuery);
